export const CATALOGUE_FEED_PLUGIN_ID = 'catalogue-feed'
